import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { environment } from 'environments/environment';

@Injectable()
export class UtilService {
    private apiViaCEP = environment.apiConsultaCEP;
    private apiCNPJ = environment.apiReceitaFederalConsultaCNPJ;
    private _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    constructor(private http: HttpClient) { }

    private _utf8_encode(e) {
        e = e.replace(/rn/g, "n");
        var t = "";
        for (var n = 0; n < e.length; n++) {
            var r = e.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r);
            } else if (r > 127 && r < 2048) {
                t += String.fromCharCode(r >> 6 | 192);
                t += String.fromCharCode(r & 63 | 128);
            } else {
                t += String.fromCharCode(r >> 12 | 224);
                t += String.fromCharCode(r >> 6 & 63 | 128);
                t += String.fromCharCode(r & 63 | 128);
            }
        }
        return t;
    }
    private _utf8_decode(e) {
        var t = "";
        var n = 0;
        var r = 0;
        // var c1 = 0;
        var c2 = 0;
        while (n < e.length) {
            r = e.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r);
                n++;
            } else if (r > 191 && r < 224) {
                c2 = e.charCodeAt(n + 1);
                t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                n += 2
            } else {
                c2 = e.charCodeAt(n + 1);
                var c3 = e.charCodeAt(n + 2);
                t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                n += 3
            }
        }
        return t;
    }
    public decode(e) {
        var t = "";
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        e = e.replace(/[^A-Za-z0-9+/=]/g, "");
        while (f < e.length) {
            s = this._keyStr.indexOf(e.charAt(f++));
            o = this._keyStr.indexOf(e.charAt(f++));
            u = this._keyStr.indexOf(e.charAt(f++));
            a = this._keyStr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) {
                t = t + String.fromCharCode(r);
            }
            if (a != 64) {
                t = t + String.fromCharCode(i);
            }
        }
        t = this._utf8_decode(t);
        return t;
    }
    public encode(e) {
        var t = "";
        var n, r, i, s, o, u, a;
        var f = 0;
        e = this._utf8_encode(e);
        while (f < e.length) {
            n = e.charCodeAt(f++);
            r = e.charCodeAt(f++);
            i = e.charCodeAt(f++);
            s = n >> 2;
            o = (n & 3) << 4 | r >> 4;
            u = (r & 15) << 2 | i >> 6;
            a = i & 63;
            if (isNaN(r)) {
                u = a = 64;
            } else if (isNaN(i)) {
                a = 64;
            }
            t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
        }
        return t;
    }

    /**
     * Recupera as informações de CEP
     */
    public verificaCEP(cep: string): Promise<any> {
        return new Promise((resolve, reject) => {

            const url = this.apiViaCEP.replace('_CEP_', cep) + '?callback=callback';
            this.http.jsonp(url, 'callback')
                .subscribe(
                    data => {
                        resolve(data);
                    },
                    error => {
                        reject(error);
                    }
                );
        });
    }

  /**
   * Lista municípios por UF (API IBGE)
   */
  public getMunicipiosPorUF(uf: string): Promise<Array<{ id: number; nome: string }>> {
    return new Promise((resolve, reject) => {
      if (!uf) {
        resolve([]);
        return;
      }
      const url = `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`;
      this.http.get(url).subscribe(
        (data: any[]) => {
          resolve((data || []).map(m => ({ id: m.id, nome: m.nome })));
        },
        error => reject(error)
      );
    });
  }

    /**
     * Recupera as informações da empresa no webservice da receita federal
     */
    public verificaCNPJReceita(cnpj: string): Promise<any> {
        return new Promise((resolve, reject) => {

            const url = this.apiCNPJ + cnpj;
            this.http.jsonp(url, 'callback')
                .subscribe(
                    data => {
                        resolve(data);
                    },
                    error => {
                        reject(error);
                    }
                );
        });
    }

    /**
     * Valida o formato de entrada do email
     * @param email e-mail para validação
     */
    public static validateEmail(email) {
        if (email === '' || typeof email === 'undefined') {
            return true;
        }
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    /**
     * Rejeita texto vazio após trim, caracteres de controle, sequências triviais (ex.: "aaaaa")
     * e conteúdo só com espaços/pontuação sem letras ou dígitos (acentos latinos comuns permitidos).
     */
    public static validateMeaningfulText(
        value: string | undefined | null,
        options?: { optional?: boolean; minLength?: number },
    ): boolean {
        const opt = options || {};
        const minLen = opt.minLength !== undefined ? opt.minLength : 2;
        if (value === null || value === undefined || value === '') {
            return !!opt.optional;
        }
        const s = String(value).trim();
        if (s === '') {
            return !!opt.optional;
        }
        if (/[\x00-\x08\x0B\x0C\x0E-\x1F]/.test(s)) {
            return false;
        }
        if (s.length < minLen) {
            return false;
        }
        if (/^(.)\1{4,}$/.test(s)) {
            return false;
        }
        if (!/[a-zA-ZÀ-ÿ0-9]/.test(s)) {
            return false;
        }
        return true;
    }

    /**
     * Valida o formato do CPF
     * @param cpf CPF para validação
     */
    public static validateCPF(cpf) {
        if (cpf === '' || typeof cpf === 'undefined') {
            return true;
        }
        const re = /^[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}$/;
        return re.test(cpf) && this.validaDigitoCPF(cpf);
    }

    /**
     * Valida o formato do CNPJ
     * @param cnpj CPF para validação
     */
    public static validateCNPJ(cnpj) {
        if (cnpj === '' || typeof cnpj === 'undefined') {
            return true;
        }
        const re = /^[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2}$/;
        return re.test(cnpj);
    }

    /**
     * Valida entrada de CPF ou CNPJ
     * @param cpf CPF ou CNPJ para validação
     */
    public static validateCPF_CNPJ(cpf) {
        return this.validateCNPJ(cpf) || this.validateCPF(cpf);
    }

    /**
     * Valida padrão de formato de senha
     * @param senha senha de autenticação para validação
     */
    public static validateSenha(senha) {
        const regSenha = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,12}$/;
        return regSenha.test(senha);
    }

    public static validaDigitoCPF(cpf: string): boolean {
        cpf = cpf.replace(/\D+/g, '');
        if (cpf == null) {
            return false;
        }
        if (cpf.length != 11) {
            return false;
        }
        if ((cpf == '00000000000') || (cpf == '11111111111') || (cpf == '22222222222') || (cpf == '33333333333') || (cpf == '44444444444') || (cpf == '55555555555') || (cpf == '66666666666') || (cpf == '77777777777') || (cpf == '88888888888') || (cpf == '99999999999')) {
            return false;
        }
        let numero: number = 0;
        let caracter: string = '';
        let numeros: string = '0123456789';
        let j: number = 10;
        let somatorio: number = 0;
        let resto: number = 0;
        let digito1: number = 0;
        let digito2: number = 0;
        let cpfAux: string = '';
        cpfAux = cpf.substring(0, 9);
        for (let i: number = 0; i < 9; i++) {
            caracter = cpfAux.charAt(i);
            if (numeros.search(caracter) == -1) {
                return false;
            }
            numero = Number(caracter);
            somatorio = somatorio + (numero * j);
            j--;
        }
        resto = somatorio % 11;
        digito1 = 11 - resto;
        if (digito1 > 9) {
            digito1 = 0;
        }
        j = 11;
        somatorio = 0;
        cpfAux = cpfAux + digito1;
        for (let i: number = 0; i < 10; i++) {
            caracter = cpfAux.charAt(i);
            numero = Number(caracter);
            somatorio = somatorio + (numero * j);
            j--;
        }
        resto = somatorio % 11;
        digito2 = 11 - resto;
        if (digito2 > 9) {
            digito2 = 0;
        }
        cpfAux = cpfAux + digito2.toString();
        if (cpf != cpfAux) {
            return false;
        }
        else {
            return true;
        }
    }

    public static convertData(data): Date {
        if (data == null || data == undefined || data == '') {
            return null;
        }
        
        const dt = data.split('/');
        return new Date(dt[2], parseInt(dt[1]) - 1, dt[0]);
    }

    public convertDataBR(data): string {
        if (data == null || data == undefined || data == '') {
            return null;
        }

        let splitCaracter = '-';
        if(data.includes('/')) splitCaracter = '/';

        const dt = data.split(splitCaracter);
        return dt[2] + '/' + dt[1] + '/' + dt[0];
    }

    public downloadFile(data: any, filename: string): string {
        const url = window.URL.createObjectURL(data);

        // create hidden dom element (so it works in all browsers)
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);

        // create file, attach to hidden element and open hidden element
        a.href = url;
        a.download = this.defineNomeArquivo(filename);
        a.click();
        return url;
    }

    /// Define o nome do arquivo a ser salvo
    /// entrada: nome => nome do arquivo
    public defineNomeArquivo(nome): string {
        let data = new Date();
        let dia = ('0' + data.getDate().toString()).slice(-2);
        let mes = ('0' + (data.getMonth() + 1).toString()).slice(-2);
        let ano = data.getFullYear().toString();
        let tempo = ('0' + data.getHours().toString()).slice(-2) + ('0' + data.getMinutes().toString()).slice(-2);
        return `${nome}-${ano}${mes}${dia}-${tempo}.xlsx`
    }

    /// Define o nome do arquivo a ser salvo
    /// entrada: nome => nome do arquivo
    public defineNomeArquivoPDF(nome): string {
        let data = new Date();
        let dia = ('0' + data.getDate().toString()).slice(-2);
        let mes = ('0' + (data.getMonth() + 1).toString()).slice(-2);
        let ano = data.getFullYear().toString();
        let tempo = ('0' + data.getHours().toString()).slice(-2) + ('0' + data.getMinutes().toString()).slice(-2);
        return `${nome}-${ano}${mes}${dia}-${tempo}.pdf`
    }

    public consultaAmbiente() {
        return this.http.get(environment.urlAPI + '/teste');
    }


    // ================================
    // UTILITÁRIOS PARA DATAS (compatível com Angular 4)
    // ================================
      /**
       * Método auxiliar para padLeft (TypeScript 2.5.2 compatibility)
       */
      public padLeft(str: string, targetLength: number, padString: string = '0'): string {
        if (str.length >= targetLength) {
          return str;
        }
        
        const padLength = targetLength - str.length;
        let pad = '';
        
        for (let i = 0; i < padLength; i++) {
          pad += padString;
        }
        
        return pad + str;
      }
    
      /**
       * Converte Date object para ISO date string (yyyy-MM-dd)
       */
      public dateToISOString(date: Date): string {
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
          return '';
        }
        
        const year = date.getFullYear();
        const month = this.padLeft((date.getMonth() + 1).toString(), 2, '0');
        const day = this.padLeft(date.getDate().toString(), 2, '0');
        
        return `${year}-${month}-${day}`;
      }
    
      /**
       * Converte data brasileira (dd/MM/yyyy) para ISO date string (yyyy-MM-dd)
       */
      public brazilianToISOString(dateString: string): string {
        if (!dateString || dateString.trim() === '') {
          return '';
        }
        
        try {
          const parts = dateString.split('/');
          const day = this.padLeft(parts[0], 2, '0');
          const month = this.padLeft(parts[1], 2, '0');
          const year = parts[2];
          return `${year}-${month}-${day}`;
        } catch (error) {
          console.warn('Erro ao converter data brasileira:', dateString, error);
          return '';
        }
      }
    
      /**
       * Valida se a string está no formato ISO (yyyy-MM-dd)
       */
      public isValidISODate(dateString: string): boolean {
        const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (!isoDateRegex.test(dateString)) return false;
        
        const date = new Date(dateString);
        return date instanceof Date && !isNaN(date.getTime());
      }
    
      /**
       * Converte ISO date string para formato brasileiro (dd/MM/yyyy)
       */
      public isoToBrazilianString(isoDate: string): string {
        if (!isoDate || isoDate.trim() === '') {
          return '';
        }
        
        try {
          const parts = isoDate.split('-');
          const year = parts[0];
          const month = parts[1];
          const day = parts[2];
          return `${day}/${month}/${year}`;
        } catch (error) {
          console.warn('Erro ao converter data ISO:', isoDate, error);
          return '';
        }
      }
}



// WEBPACK FOOTER //
// /app/src/app/services/util.service.ts